export const version = '2.67.0';
//# sourceMappingURL=version.js.map